/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable import/no-anonymous-default-export */
import React, { useState } from "react";
import { Container, Row, Col, Tab, Nav } from "react-bootstrap";
import "./LandingLeadPage.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAngleDown,
  faArrowDown,
  faArrowRight,
  faCalendarAlt,
  faFileAlt,
  faFileArchive,
  faQuoteLeft,
  faVideoCamera,
} from "@fortawesome/free-solid-svg-icons";

export default ({ props }) => {
  const scrollHandler = (id) => {
    var element = document.getElementById(id);
    window.scrollTo(0, element.offsetTop - 80);
  };
  return (
    <div className="landing-lead-page text-dark-5 bg-white">
      <header className="landing-page-header py-4 py-md-5">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-3 col-4">
              <a href="/dashboard" className="logo">
                <img src="./assets/images/logo-2.png" alt="logo" />
              </a>
            </div>
            <div className="col-md-9">
              <ul className="d-flex justify-content-md-end mb-0 align-items-center">
                <li>
                  <a href="/mentors" className="font-weight-bold">
                    For Mentors
                  </a>
                </li>
                <li className="ml-2 ml-md-4">
                  <a href="/employers" className="font-weight-bold">
                    For Employers
                  </a>
                </li>
                <li className="ml-2 ml-md-4">
                  <a
                    href="/sign-in"
                    className="btn btn-green btn-big text-uppercase font-weight-bold"
                  >
                    Sign In
                  </a>
                </li>
                <li className="ml-2 ml-md-4">
                  <a
                    href="/sign-up"
                    className="btn btn-green btn-big text-uppercase font-weight-bold"
                  >
                    Sign Up
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </header>

      <div className="landing-lead-page-banner text-center">
        <h1 className="text-dark-8">Most efficient job search.</h1>
        <h2 className="mb-2 font-weight-normal">Elevated Profile Page.</h2>
        <h2 className="mb-5 font-weight-normal">
          <span className="text-green">See what you can do</span> with yours.
        </h2>
        <a
          href="/sign-up"
          className="btn btn-big btn-green text-uppercase font-weight-bold"
        >
          Join Now
        </a>

        <p className="mt-5 mb-4">See Features</p>
        <button
          className="border-0 bg-transparent"
          onClick={() => scrollHandler("DemoSection")}
        >
          <FontAwesomeIcon icon={faAngleDown} />
        </button>
      </div>

      <div
        className="landing-lead-page-features text-center bg-light-5 py-5 "
        id="DemoSection"
      >
        <div className="container py-md-5">
          <h2 className="mb-4 font-weight-normal text-dark-8">
            Complex Process. <span className="text-light-5">Simplified.</span>
          </h2>
          <h3 className="mb-5 font-weight-normal  text-dark-8">
            Hire mentor vetted and qualified candidates instantly
          </h3>
          <div className="row">
            <div className="col-md-4">
              <div className="feature-box-2 ">
                <div className="icon text-green-2 mb-4">
                  <FontAwesomeIcon icon={faVideoCamera} />
                </div>
                <h4 className="mb-4 text-dark-6">Assessment Kits</h4>
                <p className="font-weight-bold text-dark-5">
                  {" "}
                  Video record your responses to the most common interview
                  questions specific to your skillset
                </p>
              </div>
            </div>
            <div className="col-md-4">
              <div className="feature-box-2 ">
                <div className="icon text-green-2 mb-4">
                  <FontAwesomeIcon icon={faCalendarAlt} />
                </div>
                <h4 className="mb-4 text-dark-6">Calendar URL</h4>
                <p className="font-weight-bold text-dark-5">
                  Link your calendar and let employers know your interview
                  availability and book a time
                </p>
              </div>
            </div>
            <div className="col-md-4">
              <div className="feature-box-2 ">
                <div className="icon text-green-2 mb-4">
                  <FontAwesomeIcon icon={faFileAlt} />
                </div>
                <h4 className="mb-4 text-dark-6">Profile Page</h4>
                <p className="font-weight-bold text-dark-5">
                  Your resume, video assessments and calendar all in one place.
                  Stand out and be instantly hireable
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="landing-lead-page-reviews text-center  my-5 ">
        <div className="container py-md-5">
          <h2 className="mb-5 font-weight-normal text-dark-8">
            Rave Reviews{" "}
            <span className="text-light-5">From Our Early Users. </span>
          </h2>
          <div className="icon text-green-2 mb-5">
            <FontAwesomeIcon icon={faQuoteLeft} />
          </div>
          <div className="">
            <p className="mb-5 text-left">
              Assessment kits literally saved me hundreds of hours not answering
              the same questions in every interview. Who knew such a simple
              thing can be so helpful.
            </p>
            <h4 className="text-green font-weight-normal">— Max</h4>
          </div>
        </div>
      </div>

      <div className="landing-lead-page-highlight my-5">
        <div className="container py-md-5">
          <div className="col-md-10 px-0 mx-auto">
            <h2 className="mb-4 text-black font-weight-bold">
              Smarter not Harder
            </h2>
            <p className="mb-5 pt-3">
              Stand out in a crowd of aspiring candidates by having all your
              information readily available
            </p>
            <div className="highlight-box mb-4">
              <div className="row align-items-start">
                <div className="col-3">
                  <div className="count font-weight-bold text-green">01</div>
                </div>
                <div className="col-9">
                  <div className="content">
                    <h3 className="text-black mb-3 font-weight-bold">
                      Let them see
                    </h3>
                    <p>
                      Why wait for an interview to show your knowledge. Our
                      one-way video assessment kits let you record video
                      responses to most common interview questions.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="highlight-box mb-4">
              <div className="row align-items-start">
                <div className="col-3">
                  <div className="count font-weight-bold text-green">02</div>
                </div>
                <div className="col-9">
                  <div className="content">
                    <h3 className="text-black mb-3 font-weight-bold">
                      Let them meet
                    </h3>
                    <p>
                      No more phone calls and emails just to pick a time to
                      meet. Your calendar tells the employers your next
                      availability and lets them book a time with you.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="highlight-box mb-4">
              <div className="row align-items-start">
                <div className="col-3">
                  <div className="count font-weight-bold text-green">03</div>
                </div>
                <div className="col-9">
                  <div className="content">
                    <h3 className="text-black mb-3 font-weight-bold">
                      Resume{" "}
                    </h3>
                    <p>
                      Add your resume to your unique profile page to complete
                      the picture
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="highlight-box mb-4">
              <div className="row align-items-start">
                <div className="col-3">
                  <div className="count font-weight-bold text-green">04</div>
                </div>
                <div className="col-9">
                  <div className="content">
                    <h3 className="text-black mb-3 font-weight-bold">Extras</h3>
                    <p>
                      Add links to your GitHub, StackOverflow and LinkedIn to
                      make you stand out
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="highlight-box mb-4">
              <div className="row align-items-start">
                <div className="col-3">
                  <div className="count font-weight-bold text-green">05</div>
                </div>
                <div className="col-9">
                  <div className="content">
                    <h3 className="text-black mb-3 font-weight-bold">
                      More Coming
                    </h3>
                    <p>
                      We are constantly adding integrations and features like
                      background checks, verified employment history, education
                      verification and mentorship to help you find your dream
                      job.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="landing-lead-page-mentorship text-center  my-5">
        <div className="container py-md-5">
          <div className="col-md-10 mx-auto">
            <h5 className="font-weight-bold text-dark-7 mb-4">Mentorship</h5>
            <h1 className="mb-4 text-black font-weight-bold">
              Got the experience? Become a mentor instead.
            </h1>
            <p className="mb-4 text-black">
              Earn serious dough while helping folks find their dream job.
              Interview and mentor. Choose your own hours.
            </p>
            <a href="#" className="btn btn-big btn-green font-weight-bold">
              Learn More
            </a>
          </div>
        </div>
      </div>
      <footer className="landing-lead-page-footer py-4">
        <div className="container text-white text-center py-2 font-weight-bold">
          <p className="mb-0">
            © Copyright 2023 • Jigsaw •{" "}
            <a href="/privacy-policy" className="text-white">
              Privacy Policy
            </a>
          </p>
        </div>
      </footer>
    </div>
  );
};
